module.exports = __webpack_public_path__ + "static/media/turing.3dd56c10.webp";